@if ({ isTablet: isTablet$ | async, expanded: expanded$ | async }; as drawerVars) {
  <kendo-drawer-container class="aos-kendo-drawer-container-component">
    <kendo-drawer
      #drawer
      class="aos-kendo-drawer-component"
      mode="push"
      [mini]="true"
      [width]="(drawerWidth$ | async)!"
      [miniWidth]="96"
      [expanded]="drawerVars.expanded!"
    >
      <ng-template kendoDrawerTemplate>
        <aos-side-menu
          [expanded]="drawerVars.expanded!"
          (toggleClicked)="toggleDrawer(drawer)"
        ></aos-side-menu>
      </ng-template>
    </kendo-drawer>
    <kendo-drawer-content class="aos-kendo-drawer-content-component">
      <aos-page></aos-page>
    </kendo-drawer-content>
  </kendo-drawer-container>
}
<ng-container #modalContainer></ng-container>
